import { Vue, Component, Prop } from 'vue-property-decorator';
import * as DB from 'interfaces/database';
import Template from './template.vue';

@Component({})
export default class PriceDetails extends Vue.extend(Template) {
	@Prop({
		type: Object,
		required: true,
	})
	public readonly data!: DB.OfferingModel
}
